import { Observable } from 'rxjs';

export function fromMediaQueryListEvent(mobileQueryList: MediaQueryList) {
	return new Observable<MediaQueryListEvent>(observer => {
		function change(ev: MediaQueryListEvent) {
			observer.next(ev);
		}
		if (
			typeof mobileQueryList.addEventListener === 'function'
			&& typeof mobileQueryList.removeEventListener === 'function'
		) {
			mobileQueryList.addEventListener('change', change);
			return () => {
				mobileQueryList.removeEventListener('change', change);
			};
		}
		return () => {
			// noop
		};
	});
}
